import { render, staticRenderFns } from "./ProductConfiguratorFlavour.vue?vue&type=template&id=228163ba&scoped=true&"
import script from "./ProductConfiguratorFlavour.vue?vue&type=script&lang=js&"
export * from "./ProductConfiguratorFlavour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228163ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228163ba')) {
      api.createRecord('228163ba', component.options)
    } else {
      api.reload('228163ba', component.options)
    }
    module.hot.accept("./ProductConfiguratorFlavour.vue?vue&type=template&id=228163ba&scoped=true&", function () {
      api.rerender('228163ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductConfiguratorFlavour.vue"
export default component.exports